/** Mirror of backend control type aliases for durable URL filters. */
const ALIASES: Record<string, string> = {
  FIREWALL: 'HOST_FIREWALL',
  ENCRYPTION: 'DISK_ENCRYPTION',
  PATCH: 'PATCH_MANAGEMENT',
  BACKUP: 'BACKUP_RECOVERY',
  SIEM: 'SIEM_INTEGRATION',
  LOG: 'SIEM_INTEGRATION',
  LOGGING: 'SIEM_INTEGRATION',
  XDR: 'EDR',
}

export function normalizeControlType(raw: string | null | undefined): string | null {
  const key = String(raw || '')
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, '_')
  if (!key) return null
  if (ALIASES[key]) return ALIASES[key]
  return key
}
